export default __webpack_public_path__ + "static/media/getmepet.0b68802d.svg";